import { ProjectDetailsTab } from "@/components/projects/types";

export const PROJECT_WIZARD_DEFAULT_SEARCH = {
  search: "",
  document: "",
  location: [] as string[],
  status: [] as string[],
  page: "1",
};

const PROJECT_DETAILS_DEFAULT_SEARCH = {
  tab: ProjectDetailsTab.FINANCIAL_DATA,
};

const INVESTMENT_PROJECT_DETAILS_DEFAULT_SEARCH = {
  tab: ProjectDetailsTab.GENERAL_GUIDANCE,
};

export function getProjectDetailsDefaultSearch(technicalProjectType?: string) {
  return technicalProjectType === "investment"
    ? INVESTMENT_PROJECT_DETAILS_DEFAULT_SEARCH
    : PROJECT_DETAILS_DEFAULT_SEARCH;
}
